import React from "react";
import ArrowRightIcon from "@/app/shared-components/icons/ArrowRightIcon";
import { useSubscriptionCompetitionsPrizesPageContext } from "@/app/(custom-header)/prizes/[prizeName]/context";

const MoreTickets = () => {
  const { onViewPlansClick } = useSubscriptionCompetitionsPrizesPageContext();

  const setHashAndRun = (id: string, fn: () => void) => {
    const hash = id.startsWith("#") ? id : `#${id}`;

    // updates URL bar without navigating/reloading
    window.history.replaceState(null, "", hash);

    fn();
  };

  return (
    <div className={"font-jost flex items-start gap-3 self-stretch bg-white lg:bg-[#F5F5F5] px-3 py-2 rounded-lg"}>
      <img
        src="/assets/images/subscription-competitions/more-tickets.png"
        alt="tickets"
        width={30}
        height={30}
        className="w-7.5 h-auto"
      />
      <div className={"flex flex-col gap-2"}>
        <div className={"text-[#696971] font-jost text-xs font-normal leading-4"}>
          <span className={"text-sm font-medium text-black"}>Boost your chances to win</span>
          <br />
          More tickets, better odds: higher plans increase your chances in every draw.
        </div>
        <div className={"grid grid-cols-3 gap-1.5"}>
          <div
            onClick={() => setHashAndRun("Essential", () => onViewPlansClick("sc_details_boost"))}
            className={
              "bg-[#F2F2F2]  lg:bg-white grow flex flex-col rounded-[4px] min-h-14 lg:min-h-16 cursor-pointer"
            }>
            <div className={"flex justify-center items-start gap-2.5 bg-[#747474] px-1 py-0.5 rounded-t-[4px]"}>
              <span
                className={
                  "text-white text-center text-[10px] py-1.5 px-1 font-semibold leading-3 lg:text-xs lg:leading-4"
                }>
                Essential Plan
              </span>
            </div>
            <div className={"grow flex justify-center items-center gap-1.5 lg:gap-1 px-1 pt-2.5 pb-2 lg:py-2"}>
              <span className={"pl-1 text-[#4C4C52] text-center text-xs font-normal leading-4 lg:text-sm lg:leading-5"}>
                2 tickets
              </span>
              <ArrowRightIcon variant={4} className={"size-4 shrink-0 text-primary"} />
            </div>
          </div>

          <div
            onClick={() => setHashAndRun("Premium", () => onViewPlansClick("sc_details_boost"))}
            className={
              "bg-[#F2F2F2]  lg:bg-white grow flex flex-col rounded-[4px] min-h-14 lg:min-h-16 cursor-pointer"
            }>
            <div className={"flex justify-center items-start gap-2.5 bg-[#3E5FFF] px-1 py-0.5 rounded-t-[4px]"}>
              <span
                className={
                  "text-white text-center text-[10px] py-1.5 px-1 font-semibold leading-3 lg:text-xs lg:leading-4"
                }>
                Premium Plan
              </span>
            </div>
            <div className={"grow flex justify-center items-center gap-1.5 lg:gap-1 px-1 pt-2.5 pb-2 lg:py-2"}>
              <span className={"pl-1 text-[#4C4C52] text-center text-xs font-normal leading-4 lg:text-sm lg:leading-5"}>
                6 tickets
              </span>
              <ArrowRightIcon variant={4} className={"size-4 shrink-0 text-primary"} />
            </div>
          </div>

          <div
            onClick={() => setHashAndRun("Ultimate", () => onViewPlansClick("sc_details_boost"))}
            className={
              "bg-[#F2F2F2]  lg:bg-white grow flex flex-col rounded-[4px] min-h-14 lg:min-h-16 cursor-pointer"
            }>
            <div className={"flex justify-center items-start gap-2.5 bg-[#FC9E2F] px-1 py-0.5 rounded-t-[4px]"}>
              <span
                className={
                  "text-white text-center text-[10px] py-1.5 px-1 font-semibold leading-3 lg:text-xs lg:leading-4"
                }>
                Ultimate Plan
              </span>
            </div>
            <div className={"grow flex justify-center items-center gap-1.5 lg:gap-1 px-1 pt-2.5 pb-2 lg:py-2"}>
              <span className={"pl-1 text-[#4C4C52] text-center text-xs font-normal leading-4 lg:text-sm lg:leading-5"}>
                15 tickets
              </span>
              <ArrowRightIcon variant={4} className={"size-4 shrink-0 text-primary"} />
            </div>
          </div>
        </div>
        <div
          onClick={() => setHashAndRun("FreePostal", () => onViewPlansClick("sc_details_boost"))}
          className={
            "grid grid-cols-3 bg-[#F2F2F2] gap-1.5 lg:bg-white rounded-[4px] min-h-6 lg:min-h-8 cursor-pointer"
          }>
          <span
            className={
              "grow flex justify-center items-center bg-[#E7E7E9] text-[#696971] text-xs font-semibold rounded-[4px]"
            }>
            Postal Entry
          </span>
          <div className={"grow flex col-span-2 items-center gap-1.5 lg:gap-1 px-1 py-0.5"}>
            <span className={"ml-3 lg:ml-[18px] text-[#4C4C52] text-xs font-normal leading-4 lg:text-sm lg:leading-5"}>
              1 ticket
            </span>
            <ArrowRightIcon variant={4} className={"size-4 shrink-0 text-primary ml-[7px] lg:ml-[9px]"} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MoreTickets;
